// src/utils/weldPrecincts.js
// Weld County precinct lookup: Turf.js point-in-polygon against the
// Precincts GeoJSON. A single match carries the precinct number plus
// Congressional/Senate/House/Commissioner district numbers all at once.

import { point as turfPoint, booleanPointInPolygon } from '@turf/turf';

export const WELD_PRECINCTS_FILE = '/geojson/weld/Precincts_open_data_4401466600648029872.geojson';

let precinctsGeojsonCache = null;

const loadWeldPrecinctsGeojson = async () => {
  if (precinctsGeojsonCache) return precinctsGeojsonCache;
  const res = await fetch(WELD_PRECINCTS_FILE);
  if (!res.ok) throw new Error(`Failed to load ${WELD_PRECINCTS_FILE}: ${res.status}`);
  precinctsGeojsonCache = await res.json();
  return precinctsGeojsonCache;
};

// Returns the matching feature's properties — PRECCODE, CONGRESS, SENATE,
// HOUSE, COMMISS, SENCODE, HOUSECODE, COMMCODE, PRECINCT, etc. — or null.
export const lookupWeldPrecinct = async (lat, lng) => {
  const geojson = await loadWeldPrecinctsGeojson();
  const pt = turfPoint([lng, lat]);
  const feature = geojson.features.find(f => booleanPointInPolygon(pt, f));
  return feature?.properties || null;
};
